import React, {useEffect, useState} from "react"
import {TaskControls} from "../../components/task_buttons/TaskControls"
import ExportProductsApi from "../../api/ExportProductsApi"
import {appPages} from "../../App"
import {Link, match, Route, useHistory} from "react-router-dom"
import {CommandData} from "../../utils/RequestsHelper"
import ExportHistoryApi, {LaunchAnswer} from "../../api/ExportHistoryApi"
import {SkeletonBox} from "../../lib/wa-2.0"
import {observer} from "mobx-react-lite"
import StocksHistoryComponent from "./StocksHistoryComponent"
import ProductHistoryComponent from ".//ProductHistoryComponent"

export const StocksHistoryPage = observer(() => {


    return <React.Fragment>
        <Route exact path={appPages.stocksHistory + '/'} component={StocksHistoryComponent}/>
        <Route exact path={appPages.stocksHistory + '/product/:product_id'} component={ProductHistoryComponent}/>

    </React.Fragment>

})